import { Button, Col, Row } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import moment from 'moment';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from '../../../store';
import { delayMailBoxConfiguration, fetchHospitalConfig } from '../../../store/actions/mailBoxAction';
import { MailboxType } from '../../../store/models/mailBoxModel';
import { GUTTOR_SPACE } from '../../constants/commonConstants';

const EmailChannelValidator = (): ReactElement => {
  const dispatch = useDispatch();
  const { hospitalConfiguration: emailConfiguration = {} as any } = useSelector((state: RootState): MailboxType => state?.mailBox || {});
  const { passwordExpire, delayDate, delayPressCount } = emailConfiguration || {};
  const [index, setIndex] = useState<number>(0);
  const [visible, setVisible] = useState(false);
  const history = useHistory();

  useEffect((): any => {
    const providerDetail = JSON.parse(localStorage.getItem('providerDetail') || '{}');
    if (providerDetail?.providerId) {
      dispatch(fetchHospitalConfig(providerDetail?.providerId));
    }
  }, []);

  useEffect((): any => {
    if (emailConfiguration) {
      setVisible(checkIsVisible());
    } else {
      setVisible(false);
    }
  }, [delayPressCount]);

  const checkIsVisible = (): boolean => {
    if (
      passwordExpire &&
      (!delayDate || (delayDate && Math.abs(moment().diff(delayDate, 'day')) >= 1))) {
      return true;
    }
    return false;
  };

  const onClickLater = (showsecondaryModal?: any): any => {
    if (showsecondaryModal) {
      setIndex(index + 1);
    } else {
      dispatch(delayMailBoxConfiguration());
      setVisible(false);
    }
  };

  const reconfigureMailbox = (): any => {
    history?.push('/profile/mailbox/hospital');
    setVisible(false);
  };

  const modalContent = [
    {
      title: (<strong className="text-color-mailbox">Your Mailbox Credentials are Currently Expired</strong>),
      content: (
        <div>
          <p className="reconfigure-text">Please reconfigure hospital in the hospital
            configuration section on the IHX platform to continue using IHX for email channel payers</p>
          <Row gutter={GUTTOR_SPACE} className="row-cont">
            <Col md={7}>
              <Button className="w-100 mailbox-btn" onClick={(): any => onClickLater(true)}>Later</Button>
            </Col>
            <Col md={12} className="col-reconfigure-text">
              <Button type="primary" className="w-100 reconfigure-btn" onClick={reconfigureMailbox}>Reconfigure</Button>
            </Col>
          </Row>
        </div>
      ),
    },
    {
      title: <strong className="text-color-mailbox">Are You Sure ?</strong>,
      content: (
        <div>
          <p>You will not be able to use IHX  for email channel payers without  hospital reconfiguration</p>
          <Row gutter={GUTTOR_SPACE} className="row-cont">
            <Col md={7}>
            <Button className="w-100 mailbox-btn" onClick={(): any => onClickLater(false)}>Later</Button>
            </Col>
            <Col md={12} className="col-reconfigure-text">
              <Button type="primary" className="w-100 reconfigure-btn" onClick={reconfigureMailbox}>Reconfigure</Button>
            </Col>
          </Row>
        </div>
      ),
    },
  ];

  return (
    <Modal
      visible={visible}
      title={modalContent[index]?.title}
      footer={false}
      onCancel={(): any => onClickLater()}
      className="mailbox-modal"
      centered={true}
    >
      {modalContent[index]?.content}
    </Modal>
  );
};
export default EmailChannelValidator;
